import { useEffect } from 'react';
import { useObservationResultData } from './withFunctionObservationResult';
import { getResultPropKey } from '../utils/getResultPropKey';
export function useFunctionResultObservation(options) {
  const resultData = useObservationResultData(options);
  const {
    ref,
    ...data
  } = resultData != null ? resultData : {};
  if (!ref) {
    throw new Error("ref is not define for " + getResultPropKey(options == null ? void 0 : options.resultPropName));
  }
  if (!ref.current) {
    ref.current = {};
  }
  const waitForResult = fnName => {
    var _ref$current;
    const [promise, resolve, reject] = getPromiseResolveFunction();
    if (!((_ref$current = ref.current) != null && _ref$current[fnName])) {
      ref.current[fnName] = {
        listeners: [],
        prevValue: {}
      };
    }
    ref.current[fnName].listeners.push((result, hasError) => {
      if (hasError) {
        return reject(result);
      }
      return resolve(result);
    });
    return promise;
  };
  const withObservation = (obj, method) => {
    return function () {
      if (obj[method]) {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        obj[method](args);
      }
      return waitForResult(method);
    };
  };
  useEffect(() => {
    Object.keys(ref.current).forEach(fn => {
      const {
        prevValue,
        listeners
      } = ref.current[fn];
      const currentValue = data == null ? void 0 : data[fn + "Result"];
      if (prevValue.counter !== (currentValue == null ? void 0 : currentValue.counter)) {
        const {
          value,
          hasError
        } = currentValue;
        listeners.forEach(listener => {
          listener(value, hasError);
        });
        ref.current[fn].prevValue = currentValue;
      }
    });
  });
  return {
    withObservation
  };
}
function getPromiseResolveFunction() {
  let resolve;
  let reject;
  const promise = new Promise((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });
  // @ts-expect-error
  return [promise, resolve, reject];
}
//# sourceMappingURL=useFunctionResultObservation.js.map